// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1VNF_","actionsCol":"EnrolledClinics_actionsCol__3zXwk"};